import { useIntl } from 'react-intl';
import {
  INTERNATIONAL_FORMAT_OPTIONS,
  US_FORMAT_OPTIONS,
} from '../../constants';

/** <option>s for the page-format <select>, grouped so US sheet sizes don't
 * get lost in a flat list alongside the ISO ones. */
export const FormatOptions = () => {
  const intl = useIntl();

  return (
    <>
      <optgroup label={intl.formatMessage({ id: 'format.groupInternational' })}>
        {INTERNATIONAL_FORMAT_OPTIONS.map((c) => (
          <option value={c} key={c}>
            {intl.formatMessage({ id: `format.${c}` })}
          </option>
        ))}
      </optgroup>
      <optgroup label={intl.formatMessage({ id: 'format.groupUS' })}>
        {US_FORMAT_OPTIONS.map((c) => (
          <option value={c} key={c}>
            {intl.formatMessage({ id: `format.${c}` })}
          </option>
        ))}
      </optgroup>
    </>
  );
};
